import { ReactNode } from 'react';

export interface AnalyticsTabItem {
  id: string;
  label: string;
  icon?: ReactNode;
}

interface AnalyticsTabsProps {
  tabs: AnalyticsTabItem[];
  activeTab: string;
  onTabChange: (id: string) => void;
  className?: string;
}

export function AnalyticsTabs({ tabs, activeTab, onTabChange, className = '' }: AnalyticsTabsProps) {
  return (
    <div className={`flex gap-1 ${className}`}>
      {tabs.map(tab => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            type="button"
            onClick={() => onTabChange(tab.id)}
            className={`flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${
              isActive
                ? 'bg-[var(--anl-accent)] text-white'
                : 'text-[var(--anl-text-muted)] hover:bg-[var(--anl-surface-elev)] hover:text-[var(--anl-text)]'
            }`}
          >
            {tab.icon}
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
